import styled from 'styled-components'

export const OptionCardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  padding: 10px 0;
`

export const OptionCard = styled.button`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  padding: 18px 20px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  text-align: left;

  &:hover {
    background: rgba(255, 255, 255, 0.12);
    border-color: #3b82f6;
    transform: translateY(-2px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.4);
  }

  &:active {
    transform: translateY(0);
  }

  .icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: #002b80;
    color: #ffffff;
    font-size: 24px;
    flex-shrink: 0;
    transition: all 0.25s ease;

    svg {
      color: #ffffff !important;
      fill: currentColor;
    }
  }

  &:hover .icon-wrapper {
    background: #3b82f6;
    color: #ffffff;
    transform: scale(1.05);

    svg {
      color: #ffffff !important;
    }
  }

  .text-wrapper {
    display: flex;
    flex-direction: column;
    gap: 3px;

    .name {
      font-size: 15px;
      font-weight: 700;
      font-family: 'Montserrat', sans-serif;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    .desc {
      font-size: 12px;
      color: #94a3b8;
      font-weight: 500;
      line-height: 1.4;
    }
  }
`
